<template>
  <div class="home">
    <DemoDialog :showDialog="showDemoDialog" @closeDemo="closeDemoDialog" />
    <Welcome />
    <Egyszazalek />


    <v-row
      v-if="addNewPermission"
      justify=center
      >
      <v-col cols="6" class="addNewButton">
        <v-btn class="primary" to='/administration/new'>
            <v-icon>
              mdi-plus
            </v-icon>
              Új védenc
        </v-btn>
      </v-col>
    </v-row>

    <ChosenAnimal v-if="chosenanimal!==undefined" :animal="chosenanimal" />

    <AnimalSearch v-if="$store.getters.isAuthenticated" @searchResult="showSearch($event)" />

    <NavigationInside />

    <h2 class="display-2 text-center">Védenceink</h2>
    <AnimalThumbnails :searchOn="searchOn" :animals="animals"/>
  </div>
</template>

<script>
import Welcome from '../components/Welcome.vue';
import Egyszazalek from '../components/Egyszazalek/Egyszazalek.vue';
import AnimalThumbnails from '../components/AnimalThumbnails.vue';
import DemoDialog from '../components/DemoDialog.vue';
import ChosenAnimal from '../components/ChosenAnimal.vue';
import AnimalSearch from '../components/AnimalSearch.vue';
import NavigationInside from '../components/NavigationInside.vue';

export default {
  data(){
    return {
      showDemoDialog: sessionStorage.getItem('demodialog') === 'ok' ? false: true,
      animals: this.$store.getters.allAnimals,
      searchOn: false,
    }
  },
  components: {
    Welcome,
    AnimalThumbnails,
    DemoDialog,
    ChosenAnimal,
    AnimalSearch,
    NavigationInside,
    Egyszazalek,
  },
  computed:{
    addNewPermission(){
      if(this.$store.getters.hasPermissionToAddNew){
        return true;
      }else{
        return false;
      }
    },
    chosenanimal(){
        return this.$store.getters.allAnimals.filter(a=>a.animal_of_week)[0]
    },
  },
  methods:{
    closeDemoDialog(){
      this.showDemoDialog = false;
      sessionStorage.setItem('demodialog','ok')
    },
    showSearch($event){
      if($event){
        this.searchOn = true;
        this.animals = $event;
      }else{
        this.animals = this.$store.getters.allAnimals;
        this.searchOn = false;
      }
    }
  },
};
</script>

<style lang="scss" scoped>

  .addNewButton{
  text-align: center;
  }
</style>
